import {
    Box,
} from 'grommet';

const Analytics = () => {
    return (
        <Box height='100%' width='100%'>
            <iframe src="https://claim3-dashboard.streamlit.app/?embed=true" title="claim3 dashboard" height='100%' width='100%' style={{ border: 'none' }} />
        </Box>
    )
}

export default Analytics;